import React from "react";
import MVMIcon from "../../Common/MVMIcon";
const PrevButton = (props) => {
    if (props.cursor === null) {
        return null;
    }
    return (React.createElement("a", { className: "clear-btn primary-color", onClick: props.onClick },
        React.createElement(MVMIcon, { className: "rotate-back-90", icon: "right-arrow", height: 16, width: 16 }),
        " ",
        React.createElement("div", { className: "mx-1" }),
        "Load Next"));
};
export default PrevButton;
